import type { InjectState } from "./types/InjectState";

// this has to be moved to some utils folder
export const injectState: InjectState =
  (fun, state) =>
  (input, ...rest) =>
    fun(Object.assign(input ?? {}, { state }), ...rest);
